import { useState } from "react";
import { BaseService } from "@services/BaseService";
import environment from "environment";
import {
  BillingContextAddRequestV1,
  BillingContextListResponseV1,
} from "@ucchub/ui/src/apiTypes/cloudNumbers";

const useAddEditBillingContext = () => {
  const [isBillingContextSubmitting, setIsBillingContextSubmitting] =
    useState(false);

  const [billingContextName, setBillingContextName] = useState("");
  const [error, setError] = useState<string>();

  const submitAddBillingContext = (
    data: BillingContextAddRequestV1 & { orgId: string }
  ) => {
    return new Promise(function (resolve, reject) {
      setIsBillingContextSubmitting(true);
      setError("");
      const apiUrl =
        environment.api.organisationInfo +
        `/${data.orgId}` +
        "/billing-contexts";

      BaseService.post<BillingContextListResponseV1>(apiUrl, data)
        .then(({ data }) => {
          setBillingContextName(data.name);
          resolve(data);
        })
        .catch((err) => {
          let errorMessage = "An unknown error occurred";
          if (err?.response?.data?.errorCode === "IR0003") {
            errorMessage = "Billing Context name already exists";
          } else if (err?.response?.data?.message) {
            errorMessage = err.response.data.message;
          }
          setError(errorMessage);
          reject(err?.message);
        })
        .finally(() => {
          setIsBillingContextSubmitting(false);
        });
    });
  };

  return {
    isBillingContextSubmitting,
    submitAddBillingContext,
    billingContextName,
    error,
    setError,
  };
};

export default useAddEditBillingContext;
